<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="$config.isShowEncrypted"
        :color="securityLevelId > 2 ? 'purple' : 'info'"
        outlined
        small
        class="mb-2"
        v-bind="attrs"
        v-on="on"
      >
        {{ $t('eDocInternal.encryptedFileViewerStaff') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title style="word-break: break-word">
        {{ $t('eDocInternal.encryptedFileViewerStaff') }}
      </v-card-title>
      <v-divider />
      <div
        width="100%"
        class="px-2"
      >
        <v-list-item
          v-for="opener in openerList"
          :key="opener.euid"
          two-line
        >
          <v-list-item-content>
            <v-list-item-title>{{ opener.chinName }} <span class="font-weight-light">{{ opener.euid }}</span></v-list-item-title>
            <v-list-item-subtitle>{{ opener.portName }}</v-list-item-subtitle>
          </v-list-item-content>
          <!--
          <v-list-item-action>
            <v-list-item-action-text v-if="opener.createdByEuid">
              <v-tooltip
                top
                color="black"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    outlined
                    class="mr-2 mb-2"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ momentWithHyphen(opener.createdTime).format('YYYY-MM-DD HH:mm') }}
                  </v-chip>
                </template>
                <span>
                  {{ $chPtObjData('createdByChinName', opener) }}
                </span>
              </v-tooltip>
            </v-list-item-action-text>
            <v-list-item-action-text v-else>
              {{ $t('eDocInternal.alreadyExist') }}
            </v-list-item-action-text>
          </v-list-item-action>
          -->
        </v-list-item>
        <!-- <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>李漢城 <span class="font-weight-light">EU000005692</span></v-list-item-title>
            <v-list-item-subtitle>Lee Hong S</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text>
              2021-12-15
              <br>
              15:30
            </v-list-item-action-text>
          </v-list-item-action>
        </v-list-item> -->
      </div>
      <v-card-actions>
        <v-btn
          color="primary"
          text
          class="ml-n2"
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'

export default {
  props: {
    openerList: {
      type: Array,
      required: true
    },
    securityLevelId: {
      type: Number,
      default: 2
    }
  },
  data: function () {
    return {
      dialog: false
    }
  },
  methods: {
    momentWithHyphen: momentWithHyphen
  }
}
</script>
